$(function() {
  var lang = getParam('lang');
  var cookie = getCookie ();
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') return;

  if (lang != 'en' && cookie['lang'] === undefined && cookie['lang'] !== 'EN') {
    $.get({
      url: "https://ipinfo.io?token=4d1cdbf6c21827",
      dataType: 'jsonp'
    }).done(function(data, textStatus, jqXHR) {
          if (data.country == "JP") {
            location.href = "https://milamorejewelry.com" + location.pathname;
          } else {
            setCookie ('lang', 'EN');
          }
    }).fail(function(jqXHR, textStatus, errorThrown) {
        var language = browserLanguage();
        if (language === 'ja') {
            location.href = "https://milamorejewelry.com" + location.pathname;
        }
    });
  }
});

function browserLanguage() {
	try {
	  return (navigator.browserLanguage || navigator.language || navigator.userLanguage).substr(0,2)
	}
	catch(e) {
	  return undefined;
	}
}

function getParam(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

/*
	* cookieの取得
	*/
function getCookie () {
	var result = new Array();
	var allcookies = document.cookie;
	if (allcookies != '') {
		var cookies = allcookies.split('; ');

		for (var i = 0; i < cookies.length; i++) {
			var cookie = cookies[i].split('=');
			result[cookie[0]] = decodeURIComponent(cookie[1]);
		}
	}
	return result;
}

/*
	* cookieの保存
	*/
function setCookie (key, value) {
	var date = new Date();
	var expire = new Date();
	expire.setTime(date.getTime() + 1000 * 3600 * 24 * 7);
	document.cookie = key + '=' + value + ';path=/; expires=' + expire.toUTCString();
}

